var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"d-flex flex-column"},[_c('h5',[_vm._v("Not Found")]),_c('p',[_vm._v(" Unrecognized path: "+_vm._s(_vm.path)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }